export const ValidationRule = {
  STRING_REQUIRED: {
    type: 'string',
    required: true,
    message: 'Must not be empty',
  },
};
